import { useMutation } from '@tanstack/react-query';

import {
  type CreateCounterOfferRequest,
  type OfferErrorResponse,
} from '../aliases';
import { createCounterOffer } from '../api';

import { type AxiosCompatibleError } from '@/modules/http/types';

type Props = {
  offerId: string;
  onSuccess?: () => void;
  onError?: (error: OfferErrorResponse) => void;
};

export function useCounterOfferMutation({
  offerId,
  onSuccess,
  onError,
}: Props) {
  return useMutation({
    mutationFn: (body: CreateCounterOfferRequest) =>
      createCounterOffer(offerId, body),
    onSuccess,
    onError: async (error: AxiosCompatibleError<OfferErrorResponse>) => {
      const errorData = error?.response?.data;

      if (onError) {
        onError(errorData);
      }
    },
  });
}
